import WysiwygBlock from 'components/WysiwygBlock/WysiwygBlock'

export default WysiwygBlock
